var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHouseConsumption(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.986816,
    width: 38,
    height: 38,
    rx: 19,
    fill: "#B9C7D8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.1 18.1751V13.8103H22.7V15.9515L19.5 12.9868L11.5 20.3986H13.9V26.9868H17.9V22.0456H21.1V26.9868H25.1V20.3986H27.5L25.1 18.1751ZM17.9 18.7515C17.9 17.8456 18.62 17.1045 19.5 17.1045C20.38 17.1045 21.1 17.8456 21.1 18.7515H17.9Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHouseConsumption);
export default __webpack_public_path__ + "static/media/house-consumption.33b42152071fbb15692597ff06dca10c.svg";
export { ForwardRef as ReactComponent };